import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-cancel-support-doc',
    templateUrl: './cancel-support-doc.component.html',
    styleUrls: ['./cancel-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CancelSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
